import axios from 'axios';

import type { TFindOneBatchInfosLocations } from '../../../types/TBatchGoogleModules';

export const findOneBatchInfos = async ({
  batchInfosLocationId,
  isFetching,
  userAccessToken,
}: TFindOneBatchInfosLocations): Promise<{
  status: 'SUCCESS' | 'ERROR';
  data: any;
}> => {
  try {
    if (isFetching) isFetching(true);

    const { data } = await axios.get(
      `${process.env.REACT_APP_SAAS_BATCH_GOOGLE_MODULES}/batch-infos/${batchInfosLocationId}`,
      {
        headers: {
          Authorization: `Bearer ${userAccessToken}`,
        },
      },
    );
    return {
      status: 'SUCCESS',
      data,
    };
  } catch (err: any) {
    return {
      status: 'ERROR',
      data: err.response,
    };
  } finally {
    if (isFetching) isFetching(false);
  }
};
